import { InjectionToken } from '@angular/core';

export const DEFAULT_PAGE = new InjectionToken('Default Site Page', {
    providedIn: 'root',
    factory: () => '/'
});